import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class ProjectModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (ProjectModel._instance == null) ProjectModel._instance = new ProjectModel(authManager);
        return ProjectModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'projects/projects');

        this.entityName = 'projects.Project';
        this.privileges = {
            create: [["adminProjects"],["manageProjects"]],
            read: [["adminProjects"],["manageProjects"],["editProjects"],["readProjects"]],
            update: [["adminProjects"],["manageProjects"],["editProjects"]],
            delete: [["adminProjects"],["manageProjects"]],
        };

        this.label = 'Project';
        this.setLabel = 'Projects';

        this.browser = {
            name: 'default-projects-project-browser',
            moduleName: 'default-projects-project-browser',
            moduleTitle: 'Projects',
            moduleStateSlotName: 'default-projects-project-browser',
        };

        this.editor = {
            name: 'default-projects-project-editor',
            moduleName: 'default-projects-project-editor',
            moduleTitle: 'Project',
            moduleStateSlotName: 'default-projects-project-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'mainLink',
                type: 'string',
                persistent: true,
                label: 'Main Link',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'ownerId',
                type: 'User',
                persistent: true,
                label: 'Owner',
                readOnly: true,
            },
            {
                name: 'ownerLabel',
                type: 'string',
                persistent: false,
                label: 'Owner',
                distinctLabel: 'Owner (Text)',
                readOnly: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
